import(/* webpackMode: "eager" */ "/home/fivestars/src/app/global-error.tsx");
